import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BottomTabNav from "../../customs/BottomTabNav";
import DynamicImageFields from "../../customs/DynamicImageFields";
import ImageField from "../../customs/ImageField";
import { createRestaurantDocument } from "../../../../actions/restaurantAction";


export default function Documents(props) {
  const [documents, setDocuments] = useState([])
  const [papers, setPapers] = useState([])
  const { restaurant_id } = useSelector(state => state.restaurant)
  const dispatch = useDispatch()

  const handler = (ename, data) => {
    let prevDocs = [...documents]
    const newDoc = { [ename]: data }
    prevDocs.push(newDoc)
    setDocuments(prevDocs)
  }

  const updateChef = async () => {
    await dispatch(createRestaurantDocument(restaurant_id, documents))
  }

  return (
    <fieldset>
      <ImageField
        name="restaurant_image"
        title="Profile Image"
        id="restaurant_image"
        minSize="800 x 800"
        accepts={[".jpeg", ".png", ".jpg"]}
        style={{ height: 160, width: 160 }}
        handler={(data) => handler('restaurant_image', data)}
      />
      <ImageField
        name="banner_image"
        title=" Banner Image"
        id="banner_image"
        minSize="1024 x 576"
        accepts={[".jpeg", ".png", ".jpg"]}
        style={{ width: 205, height: 116 }}
        handler={(data) => handler('banner_image', data)}
      />

      <DynamicImageFields title="Document Name" />
      <BottomTabNav currentStep={2} props={props} data={documents} handler={updateChef} />
    </fieldset>
  );
}
